export default {
    install (Vue) {
        
        Vue.prototype.$globals = {
            buildApiUrl: "https://zen.zenapptic.com:8082/",
            bridgeApiUrl: "https://zen-bridge.azurewebsites.net/api/"
        }
    }
}